"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledRatingStarsMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _RatingStars = require("../../components/RatingStars/RatingStars.styles");
var _TextButton = require("../../components/TextButton/TextButton.styles");
var _spaceMixin = require("../spaceMixin");
var _TextButtonMixin = require("./TextButtonMixin");
/** @class LabeledRatingStars */
/** @method */
var LabeledRatingStarsMixin = function LabeledRatingStarsMixin(props) {
  return (0, _styledToken.default)({
    buttonType: 'LabeledRatingStars.buttonType',
    fontType: 'LabeledRatingStars.fontType',
    marginRight: 'LabeledRatingStars.marginRight'
  }, function (_ref) {
    var _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'secondary' : _ref$buttonType,
      _ref$fontType = _ref.fontType,
      fontType = _ref$fontType === void 0 ? 'bodySmall' : _ref$fontType,
      marginRight = _ref.marginRight;
    return (0, _styledComponents.css)(["display:inline-flex;align-items:center;", "{margin-right:", ";}", "{", "}"], _RatingStars.StyledRatingStars, marginRight ? marginRight + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), _TextButton.StyledTextButton, (0, _TextButtonMixin.TextButtonMixin)(Object.assign({}, props, {
      buttonType: buttonType,
      fontType: fontType
    })));
  })(props);
};
exports.LabeledRatingStarsMixin = LabeledRatingStarsMixin;